import { globalAxios, coreInstance } from "./../index";
import { i18n } from './../../plugins/i18n';
import moment from "moment";
export default {
  namespaced: true,
  state: {
    editingStoreDetail: false,
    homepageDetail: {},
    selectedBannerText: {},
    storeDetail: {},
    cloneStoreDetail: {},
    StoreTimeList: [
      {
        day: "จ.",
        day_en: 'mon.',
        name: "mon",
        time_start: '',
        time_end: '',
        dialog_start: false,
        dialog_end: false,
        active: 0,
        round: 1
      },
      {
        day: "จ.",
        day_en: 'Mon.',
        name: "mon2",
        time_start: '',
        time_end: '',
        dialog_start: false,
        dialog_end: false,
        active: 0,
        round: 2
      },
      {
        day: "อ.",
        day_en: 'Tue.',
        name: "tue",
        time_start: '',
        time_end: '',
        dialog_start: false,
        dialog_end: false,
        active: 0,
        round: 1
      },
      {
        day: "อ.",
        day_en: 'Tue.',
        name: "tue2",
        time_start: '',
        time_end: '',
        dialog_start: false,
        dialog_end: false,
        active: 0,
        round: 2
      },
      {
        day: "พ.",
        day_en: 'Wed.',
        name: "wed",
        time_start: '',
        time_end: '',
        dialog_start: false,
        dialog_end: false,
        active: 0,
        round: 1
      },
      {
        day: "พ.",
        day_en: 'Wed.',
        name: "wed2",
        time_start: '',
        time_end: '',
        dialog_start: false,
        dialog_end: false,
        active: 0,
        round: 2
      },
      {
        day: "พฤ.",
        day_en: 'Thu.',
        name: "thu",
        time_start: '',
        time_end: '',
        dialog_start: false,
        dialog_end: false,
        active: 0,
        round: 1
      },
      {
        day: "พฤ.",
        day_en: 'Thu.',
        name: "thu2",
        time_start: '',
        time_end: '',
        dialog_start: false,
        dialog_end: false,
        active: 0,
        round: 2
      },
      {
        day: "ศ.",
        day_en: 'Fri.',
        name: "fri",
        time_start: '',
        time_end: '',
        dialog_start: false,
        dialog_end: false,
        active: 0,
        round: 1
      },
      {
        day: "ศ.",
        day_en: 'Fri.',
        name: "fri2",
        time_start: '',
        time_end: '',
        dialog_start: false,
        dialog_end: false,
        active: 0,
        round: 2
      },
      {
        day: "ส.",
        day_en: 'Sat.',
        name: "sat",
        time_start: '',
        time_end: '',
        dialog_start: false,
        dialog_end: false,
        active: 0,
        round: 1
      },
      {
        day: "ส.",
        day_en: 'Sat.',
        name: "sat2",
        time_start: '',
        time_end: '',
        dialog_start: false,
        dialog_end: false,
        active: 0,
        round: 2
      },
      {
        day: "อา.",
        day_en: 'Sun.',
        name: "sun",
        time_start: '',
        time_end: '',
        dialog_start: false,
        dialog_end: false,
        active: 0,
        round: 1
      },
      {
        day: "อา.",
        day_en: 'Sun.',
        name: "sun2",
        time_start: '',
        time_end: '',
        dialog_start: false,
        dialog_end: false,
        active: 0,
        round: 2
      }
    ],
    StoreTypeList: [],
    cloneStoreTimeList: [],
    storeEditedData: {},
    bannerList: [],
  },
  mutations: {
    assignStoreEditDataLatLng(state, data) {
      if (state.storeEditedData == null) {
        state.storeEditedData = {};
      }
      Object.assign(state.storeEditedData, data.store_latlng);
    },
    assignStoreEditData(state, data) {
      if (state.storeEditedData == null) {
        state.storeEditedData = {};
      }
      Object.assign(state.storeEditedData, data.store_info);
    },
    fetchDataHomePage(state, data) {
      state.homepageDetail = data;
    },
    selectBannerText(state, data) {
      state.selectedBannerText = data;
    },
    getStoreInformation(state, data) {
      let storeDetail = JSON.parse(JSON.stringify(data));
      console.log(storeDetail);
      if ('store_special_time' in storeDetail) {
        let specialTime = storeDetail.store_special_time
        storeDetail.store_special_time = specialTime.filter(val => new Date(val.store_close_date) >= new Date(new Date().toDateString()))
      }
      state.storeDetail = storeDetail;
      state.cloneStoreDetail = JSON.parse(JSON.stringify(storeDetail));

    },
    resetStoreDetail(state) {
      state.storeDetail = JSON.parse(JSON.stringify(state.cloneStoreDetail));

    },
    setCloneStoreDetail(state) {
      state.cloneStoreDetail = JSON.parse(JSON.stringify(state.storeDetail));

    },
    setStoreTimeList(state, data) {
      let objStoreTime = JSON.parse(JSON.stringify(data.store_time));
      delete objStoreTime.store_time_preorder_time;
      delete objStoreTime.store_time_preorder_day;
      delete objStoreTime.store_time_preorder_daytime;
      delete objStoreTime.store_time_store_id;
      delete objStoreTime.store_time_id;
      for (let obj in objStoreTime) {
        for (let val of state.StoreTimeList) {
          if (obj.split("_")[3] == val.name) {
            if (obj.split("_")[2] == "open") {
              if (objStoreTime[obj] != null) {
                let timestartSplit = objStoreTime[obj].split(':')
                val.time_start = timestartSplit[0] + ':' + timestartSplit[1]
                val.active = 1;
              } else {
                val.active = 0;
                val.time_start = '';
              }
            } else if (obj.split("_")[2] == "close") {
              if (objStoreTime[obj] != null) {
                let timeEndSplit = objStoreTime[obj].split(':')
                val.time_end = timeEndSplit[0] + ':' + timeEndSplit[1]
                val.active = 1;
              } else {
                val.active = 0;
                val.time_end = '';
              }
            }
          }
        }
      }

      state.cloneStoreTimeList = JSON.parse(
        JSON.stringify(state.StoreTimeList)
      );
    },
    cloneStoreOpenTime(state) {
      state.cloneStoreTimeList = JSON.parse(
        JSON.stringify(state.StoreTimeList)
      );
    },
    resetStoreTimeList(state) {
      let obj = JSON.parse(JSON.stringify(state.cloneStoreTimeList));
      for (let val of obj) {
        if (val.time_start != null && val.time_start != "") {
          val.time_start = val.time_start
        } else {
          val.time_start = ''
        }
        if (val.time_end != null && val.time_end != "") {
          val.time_end = val.time_end
        } else {
          val.time_end = ''
        }
      }
      state.StoreTimeList = obj;

    },
    deleteStoreSpecialTime(state, ID) {
      let index = state.storeDetail.store_special_time.findIndex(
        val => val.store_close_id == ID
      );
      state.storeDetail.store_special_time.splice(index, 1);
    },
    addStoreSpecialTime(state, data) {
      if (Array.isArray(data)) {
        for (let val of data) {
          if (new Date(val.store_close_date) >= new Date(new Date().toDateString())) {
            state.storeDetail.store_special_time.push(val);
          }
        }
      }
    },
    getStoreTypeList(state, data) {
      state.StoreTypeList = data;
    },
    setStoreEdited(state, data) {
      state.storeEditedData = data;
    },
    setMerchantBanner(state, list) {
      state.bannerList = list;
    }
  },
  actions: {
    editStoreLatLng({ state, commit, rootState }, form) {
      const axiosConfig = {
        headers: {
          Authorization: rootState.Auth.accToken
        }
      };
      form.store_edit_store_id = rootState.Auth.refeshStoreID;
      state.editingStoreDetail = true;
      return coreInstance
        .post("/api/v1/merChant/editStoreLatLng", form, axiosConfig)
        .then(res => {
          state.editingStoreDetail = false;
          if (res.data.token) {
            return (window.location =
              process.env.VUE_APP_MER_CORE_URL + "/signout");
          }
          if (res.data.msg == true) {
            commit("assignStoreEditDataLatLng", res.data.data);
            return true;
          } else {
            return false;
          }
        })
        .catch(err => {
          state.editingStoreDetail = false;
          return false;
        });
    },
    getStoreTypeList({ commit, rootState }, storeServiceID) {
      const axiosConfig = {
        headers: {
          Authorization: rootState.Auth.accToken
        }
      };
      return globalAxios
        .get(
          rootState.baseAPIURL + "getStoreTypeByServiceId/" + storeServiceID,
          axiosConfig
        )
        .then(res => {
          if (res.data.token) {
            return (window.location =
              process.env.VUE_APP_MER_CORE_URL + "/signout");
          }
          if (res.data.msg == true) {
            commit("getStoreTypeList", res.data.data);
            return true;
          } else {
            return false;
          }
        })
        .catch(err => false);
    },
    editStoreOpenTime({ commit, rootState }, form) {
      const axiosConfig = {
        headers: {
          Authorization: rootState.Auth.accToken
        }
      };
      form.store_time_store_id = rootState.Auth.refeshStoreID;
      return globalAxios
        .post(rootState.baseAPIURL + "setStoreTime", form, axiosConfig)
        .then(res => {
          if (res.data.token) {
            return (window.location =
              process.env.VUE_APP_MER_CORE_URL + "/signout");
          }
          commit("cloneStoreOpenTime");
          // if (res.data.msg == true) {
          return true;
          // } else {
          //   return false;
          // }
        })
        .catch(err => false);
    },
    addStoreSpecialTime({ commit, rootState }, form) {
      const axiosConfig = {
        headers: {
          Authorization: rootState.Auth.accToken
        }
      };
      form.store_close_store_id = rootState.Auth.refeshStoreID;
      return globalAxios
        .post(rootState.baseAPIURL + "SetStoreSpecial", form, axiosConfig)
        .then(res => {
          if (res.data.token) {
            return (window.location =
              process.env.VUE_APP_MER_CORE_URL + "/signout");
          }
          if (res.data.msg == true) {
            commit("addStoreSpecialTime", res.data.data);
            return true
          } else {
            return false
          }
        })
        .catch(err => false);
    },
    deleteStoreSpecialTime({ commit, rootState }, specialTimeID) {
      const axiosConfig = {
        headers: {
          Authorization: rootState.Auth.accToken
        }
      };
      return globalAxios
        .delete(
          rootState.baseAPIURL + "SetStoreSpecial/" + specialTimeID,
          axiosConfig
        )
        .then(res => {
          if (res.data.token) {
            return (window.location =
              process.env.VUE_APP_MER_CORE_URL + "/signout");
          }
          if (res.data.msg == true) {
            commit("deleteStoreSpecialTime", specialTimeID);
            return true;
          } else {
            return false;
          }
        })
        .catch(err => false);
    },
    editStoreInformation({ state, commit, rootState }, form) {
      const axiosConfig = {
        headers: {
          Authorization: rootState.Auth.accToken
        }
      };
      state.editingStoreDetail = true;
      form.store_edit_store_id = rootState.Auth.refeshStoreID;
      return coreInstance
        .post(process.env.VUE_APP_BACKEND_URL_2 + "/api/v1/merChant/editStoreInfo", form, axiosConfig)
        .then(res => {
          if (res.data.token) {
            return (window.location =
              process.env.VUE_APP_MER_CORE_URL + "/signout");
          }
          if (res.data.msg == true) {
            state.editingStoreDetail = false;
            commit("assignStoreEditData", res.data.data);
            commit("resetStoreDetail");
            return true;
          } else {
            return false;
          }
        })
        .catch(err => {
          state.editingStoreDetail = false;
          return false;
        });
    },
    getStoreInformation({ commit, rootState }) {
      commit("getStoreInformation", {});
      const axiosConfig = {
        headers: {
          Authorization: rootState.Auth.accToken
        }
      };
      return globalAxios
        .get(
          rootState.baseAPIURL +
          "restaurant/getStoreInfo/" +
          rootState.Auth.refeshStoreID,
          axiosConfig
        )
        .then(res => {
          if (res.data.token) {
            return (window.location =
              process.env.VUE_APP_MER_CORE_URL + "/signout");
          }
          if (res.data.msg == true) {
            let obj = JSON.parse(JSON.stringify(res.data.data));
            delete obj.store_edit;
            commit("getStoreInformation", obj);
            commit("setStoreTimeList", res.data.data);
            commit("setStoreEdited", res.data.data.store_edit);
            return obj;
          } else {
            return false;
          }
        })
        .catch(err => false);
    },
    ForceCloseStore({ commit, rootState }) {
      const axiosConfig = {
        headers: {
          Authorization: rootState.Auth.accToken
        }
      };
      return globalAxios
        .post(
          rootState.baseAPIURL +
          "restaurant/storeTime/setToClose/" +
          rootState.Auth.refeshStoreID,
          null,
          axiosConfig
        )
        .then(res => {
          if (res.data.token) {
            return (window.location =
              process.env.VUE_APP_MER_CORE_URL + "/signout");
          }
          if (res.data.msg == true) {
            return true;
          } else {
            return false;
          }
        })
        .catch(err => false);
    },
    ForceOpenStore({ commit, rootState }) {
      const axiosConfig = {
        headers: {
          Authorization: rootState.Auth.accToken
        }
      };
      return globalAxios
        .post(
          rootState.baseAPIURL +
          "restaurant/storeTime/setToOpen/" +
          rootState.Auth.refeshStoreID,
          null,
          axiosConfig
        )
        .then(res => {
          if (res.data.token) {
            return (window.location =
              process.env.VUE_APP_MER_CORE_URL + "/signout");
          }
          if (res.data.msg == true) {
            return true;
          } else {
            return false;
          }
        })
        .catch(err => false);
    },
    fetchDataHomePage({ commit, rootState }) {
      const axiosConfig = {
        headers: {
          Authorization: rootState.Auth.accToken
        }
      };
      return globalAxios
        .get(
          rootState.baseAPIURL +
          "restaurant/getHomeByStoreId/" +
          rootState.Auth.refeshStoreID,
          axiosConfig
        )
        .then(res => {
          if (res.data.token) {
            return (window.location =
              process.env.VUE_APP_MER_CORE_URL + "/signout");
          }
          commit("fetchDataHomePage", res.data);
        })
        .catch(err => console.log(err));
    },
    fetchBannerList({ commit, rootState }) {
      const axiosConfig = {
        headers: {
          Authorization: rootState.Auth.accToken
        },
        params: { page_size: 10, current_page: 1, banner_merchant_active: "[true]" }
      };
      return globalAxios
        .get(
          rootState.baseAPIURL +
          "get_all_banner_merchant/" + rootState.Auth.refeshStoreID,
          axiosConfig
        )
        .then(res => {
          if (res.data.token) {
            return (window.location =
              process.env.VUE_APP_MER_CORE_URL + "/signout");
          }
          commit('setMerchantBanner', res.data.data)
          return
        })
        .catch(err => console.log(err));
    },
  },
  getters: {
    getAutocompleteStoreType(state) {
      return state.StoreTypeList.map(val => val['store_type_name_' + i18n.locale]);
    }
  }
};
